import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
  errorInfo?: ErrorInfo;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Можно отправлять лог на сервер
    // eslint-disable-next-line no-console
    console.error('Uncaught error:', error, errorInfo);
    this.setState({ error, errorInfo });
  }

  private handleReload = () => {
    window.location.reload();
  };

  public render() {
    if (this.state.hasError) {
      return (
        <Container maxWidth="md" sx={{ mt: 8 }}>
          <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="h4" component="h1" gutterBottom color="error">
              Произошла ошибка
            </Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              Пожалуйста, перезагрузите страницу или попробуйте позже.
            </Typography>
            {process.env.NODE_ENV === 'development' && (
              <Box sx={{ textAlign: 'left', mt: 2 }}>
                {this.state.error && (
                  <>
                    <Typography variant="subtitle1" color="error" gutterBottom>
                      {this.state.error.message}
                    </Typography>
                    {this.state.errorInfo?.componentStack && (
                      <Box component="pre" sx={{ whiteSpace: 'pre-wrap', fontSize: 12, color: 'text.secondary' }}>
                        {this.state.errorInfo.componentStack}
                      </Box>
                    )}
                  </>
                )}
              </Box>
            )}
            <Box sx={{ mt: 2 }}>
              <Button variant="contained" startIcon={<RefreshIcon />} onClick={this.handleReload}>
                Перезагрузить
              </Button>
            </Box>
          </Paper>
        </Container>
      );
    }

    return this.props.children;
  }
}



